import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import GoogleAutocomplete from "react-google-autocomplete";
import { getGeocode, getLatLng } from "use-places-autocomplete";
import { setFilters } from "store/filters/operations";
import { getQueryParamsFromFilters } from "helpers/searchParams";
import styles from "./styles.module.scss";
import getCapacityOptions from "helpers/getCapacityOptions";
import { useTranslation } from "react-i18next";
import { Datepicker, FiltersDropdown } from "reusableComponents";

const SearchForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  const [t] = useTranslation("global");
  const [place, setPlace] = useState({ address: "", lat: null, lng: null });
  const [capacity, setCapacity] = useState(null);
  const [date, setDate] = useState(null);
  const capacityOptions = getCapacityOptions({ usages: [] }, t);
  const handlePlaceSelect = async (place) => {
    try {
      const results = await getGeocode({ address: place.formatted_address });
      const { lat, lng } = await getLatLng(results[0]);
      setPlace({
        address: place.formatted_address,
        lat,
        lng,
      });
    } catch (error) {
      console.error("Error fetching place details:", error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const filters = {
      text: place.address,
      lat: place.lat,
      lng: place.lng,
      capacity,
      from: date ? date.toISOString().split("T")[0] : null, // YYYY-MM-DD format
    };

    // Same logic as handleSearchClick
    const queryParams = getQueryParamsFromFilters(filters);
    dispatch(setFilters(filters));
    navigate(`/search?${queryParams}`);
  };

  return (
    <form className={styles.searchForm} onSubmit={handleSubmit}>
      <div className={styles.formLayout}>
        {/* First row: Place search */}
        <div className={`${styles.inputGroup} ${styles.searchInputContainer}`}>
          <label>{t("search.bar.searchPlaceholder")}</label>
          <GoogleAutocomplete
            apiKey={googleMapsApiKey}
            onPlaceSelected={handlePlaceSelect}
            options={{ types: ["establishment", "geocode"] }}
            className={styles.searchInput}
            placeholder={t("search.bar.searchPlaceholder")}
          />
        </div>

        {/* Second row: Capacity, Date, and Search Button */}
        <div className={styles.secondRow}>
          <div className={styles.inputGroup}>
            <label>{t("searchBar.persPlaceholder")}</label>
            <FiltersDropdown
              styled={false}
              options={capacityOptions}
              selected={capacity}
              onSelect={setCapacity}
              placeholder={t("searchBar.persPlaceholder")}
            />
          </div>

          <div className={styles.inputGroupWithButton}>
            <div className={styles.dateGroup}>
              <label>{t("search.bar.from")}</label>
              <Datepicker
                styled={false}
                selectedDate={date}
                onDateChange={(date) =>
                  setDate(date instanceof Date ? date : new Date(date))
                }
                minDate={new Date()}
              />
            </div>
            
            <button
              type="submit"
              className={styles.searchButton}
              // disabled={!place.address || !date}
            >
              <span className={styles.searchButtonIcon}></span>
              <span className={styles.searchButtonText}>
                {t("buttons.search") || "Search"}
              </span>
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default SearchForm;